import { render, staticRenderFns } from "./ShowNumberLine.vue?vue&type=template&id=24d6558c"
import script from "./ShowNumberLine.vue?vue&type=script&lang=js"
export * from "./ShowNumberLine.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports